// YouTube URL helpers - convert any YouTube URL into a proper embed URL.
// YouTube doesn't allow standard watch?v= URLs in iframes due to X-Frame-Options.
// Embed URLs are required for both regular videos and live streams.

export function toYouTubeEmbed(url) {
  if (!url) return "";
  const trimmed = url.trim();
  // Already an embed URL
  if (trimmed.includes("/embed/")) return trimmed;

  // Extract video ID from various YouTube URL formats
  const patterns = [
    /youtu\.be\/([^?&#/]+)/,
    /youtube\.com\/watch\?v=([^&#]+)/,
    /youtube\.com\/live\/([^?&#/]+)/,
    /youtube\.com\/v\/([^?&#/]+)/,
    /youtube\.com\/shorts\/([^?&#/]+)/,
  ];
  for (const p of patterns) {
    const m = trimmed.match(p);
    if (m && m[1]) return `https://www.youtube.com/embed/${m[1]}?autoplay=0&rel=0`;
  }

  // Channel live stream (always shows current live broadcast)
  const chMatch = trimmed.match(/youtube\.com\/channel\/([^/?#]+)/);
  if (chMatch) return `https://www.youtube.com/embed/live_stream?channel=${chMatch[1]}`;
  const handleMatch = trimmed.match(/youtube\.com\/@([^/?#]+)/);
  if (handleMatch) {
    // For @ handles we cannot direct embed; user must provide channel ID
    return trimmed;
  }

  return trimmed;
}

export function extractYouTubeId(url) {
  if (!url) return "";
  const patterns = [
    /youtu\.be\/([^?&#/]+)/,
    /youtube\.com\/watch\?v=([^&#]+)/,
    /youtube\.com\/embed\/([^?&#/]+)/,
    /youtube\.com\/live\/([^?&#/]+)/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m && m[1]) return m[1];
  }
  return "";
}

export function isYouTubeUrl(url) {
  return /youtube\.com|youtu\.be/.test(url || "");
}
